import * as React from 'react';
import classnames from 'classnames';
import {
    flexRender,
} from '@tanstack/react-table';
import { ObjectStatus } from 'features/search/filters/enums';
import { Icon } from '@atoms/Media/Icon';

import './style.scss';

export function TableRow ({
    currentItem, currentObjectId, onRowClick,
    row, columnTemplate, rowIsVisible, pricelist,
    isExpandable = false, isExpanded = false,
}) {
    const classes = classnames('table__row', {
        'table__row--hidden': !rowIsVisible,
        'table__row--expandable': isExpandable,
        'table__row--active': pricelist && (row.getValue('pricelist-apartmentNumber') === currentItem || row.getValue('pricelist-apartmentNumber') === currentObjectId),
        'table__row--for-sale': pricelist && (row.getValue('pricelist-status') === ObjectStatus.FOR_SALE),
        'table__row--reserved': pricelist && (row.getValue('pricelist-status') === ObjectStatus.RESERVED),
        'table__row--booked': pricelist && (row.getValue('pricelist-status') === ObjectStatus.BOOKED),
        'table__row--preselling': pricelist && (row.getValue('pricelist-status') === ObjectStatus.PRESELLING),
        'table__row--sold': pricelist && (row.getValue('pricelist-status') === ObjectStatus.SOLD),
    });

    return (
        <tr
            key={row.id}
            className={classes}
            aria-hidden={!rowIsVisible}
            onClick={(e) => {if (onRowClick) onRowClick(e)}}
            style={{
                gridTemplateColumns: columnTemplate,
            }}
        >
            {isExpandable && (
                <td className="table__expand-cell">
                    <span className='cell-content'><Icon name={isExpanded ? 'minus' : 'plus'} size={20} /></span>
                </td>
            )}
            {row.getVisibleCells().map(cell => (
                <td
                    key={cell.id}
                    className={cell.column.id === 'row-url' ? 'no-padd' : undefined}
                >
                    <span className='cell-content'>{flexRender(cell.column.columnDef.cell, cell.getContext())}</span>
                </td>
            ))}
        </tr>
    )
}
